"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Request for getting CompetitorPriceChangeReport.
 * @author JMr
 */


var CompetitorPriceChangeReportRequest =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorPriceChangeReportRequest, _DomainObject_1$Domai);

  /**
   * @param dateFrom
   * @param productId
   * @param priceZoneId
   * @param competitorIds
   */
  function CompetitorPriceChangeReportRequest(dateFrom, productId, priceZoneId, competitorIds) {
    var _this;

    _classCallCheck(this, CompetitorPriceChangeReportRequest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceChangeReportRequest).call(this));
    _this.dateFrom = dateFrom;
    _this.productId = productId;
    _this.priceZoneId = priceZoneId;
    _this.competitorIds = competitorIds;
    return _this;
  }

  return CompetitorPriceChangeReportRequest;
}(DomainObject_1.DomainObject);

exports.CompetitorPriceChangeReportRequest = CompetitorPriceChangeReportRequest;

CompetitorPriceChangeReportRequest.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorPriceChangeReportRequest.name);
  return {
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    productId: builder.str('productId'),
    priceZoneId: builder.str('priceZoneId'),
    competitorIds: builder.listOf(builder.str('competitorIds'))
  };
}();